import React from 'react';
import FilledStar from '../../assets/star.svg';
import LinedStar from '../../assets/lined-star.svg';
import { Box, Typography, Grid2 } from '@mui/material';

const RatingCard = ({title, rating, image, description}) => {
    const total_rating = 5
    const remaining_rating = total_rating-rating
    console.log(rating)
    // console.log(total_rating-rating)
  return (
    <Grid2 item size={{ xs: 12, md: 4 }} sx={{backgroundColor:'rgba(254, 254, 254, 1)', borderRadius:'8px', border:'1px solid rgba(243, 244, 246, 1)', p:2}}>
        <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <Box sx={{display:'flex', gap:1}}>
                <img src={image} alt={title} />
                <Typography>
                    {title}
                </Typography>
            </Box>
            <Box sx={{display:'flex', gap:1}}>
                {
                    [...Array(rating)]?.map((item, index)=>{
                        return <img src={FilledStar} alt="filled" />
                    })
                }
                {
                    [...Array(remaining_rating?remaining_rating:0)]?.map((item, index)=>{
                        return <img src={LinedStar} alt="lined-star" />
                    })
                }
            </Box>
        </Box>
        <Typography sx={{my:2}}>
            {description}
        </Typography>
    </Grid2>
  )
}

export default RatingCard